import React from "react";

const Testimonial = () => (
  <section style={{ maxWidth: 700, margin: "3rem auto 0 auto", textAlign: "center", fontStyle: "italic", color: "#222" }}>
    <div style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>
      “It was such a privilege to have you as part of the team, Tom! You have been an absolute asset – proactive, super sharp and insightful – and we will miss you.”
    </div>
    <div style={{ color: "#888", fontSize: 15, fontStyle: "normal" }}>
      London Sock Company via LinkedIn
    </div>
  </section>
);

export default Testimonial;
